import { CustomCellRendererProps } from "ag-grid-react";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { EmptyPoolStorageGenConstant } from "./EmptyPoolStorageGenConstant";

const EMP_POOL_STORAGE_GEN_CONSTANT = EmptyPoolStorageGenConstant.Charge;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF: any[] = [
    {
        headerName: EMP_POOL_STORAGE_GEN_CONSTANT.CHARGE_ON_COMPANY,
        field: 'chargeOnCompany',
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
        pinned: "left",
        checkboxSelection: true,
        headerCheckboxSelection: true,
    },
    {
        headerName: EMP_POOL_STORAGE_GEN_CONSTANT.BILL_TO_COMPANY,
        field: 'billToCompany',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    {
        headerName: EMP_POOL_STORAGE_GEN_CONSTANT.OPS_DATE,
        field: 'opsDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 130,
        dataType: "date"
    },
    {
        headerName: EMP_POOL_STORAGE_GEN_CONSTANT.OPS_LINE,
        field: 'billCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 130,
    }
]

export const INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF_OICT: any[] = [
    ...INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF,
    {
        headerName: EMP_POOL_STORAGE_GEN_CONSTANT.SOA,
        field: 'soa',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 130,
    }
].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};
    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
}
);

export const INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF_SAPT: any[] = [
    ...INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF,
].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};
    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
}
);


export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};
    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}